export default __webpack_public_path__ + "static/media/certificate.63c2bc55.svg";